// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nul[data-v-1a7f1d08] {\n  list-style: none;\n  display: table;\n  width: 100%;\n  table-layout: fixed;\n  padding-left: 8px;\n}\nli[data-v-1a7f1d08] {\n  display: table-row;\n}\nb[data-v-1a7f1d08] {\n  display: table-cell;\n  width: 150px;\n}\nspan[data-v-1a7f1d08] {\n  display: table-cell;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.dialog[data-v-1a7f1d08] {\n  max-width: 100vw;\n}\n", ""]);
// Exports
module.exports = exports;
